import { Component, Input } from '@angular/core';
import { JobBoard } from '@app/models/recruiting/job-board.model';
import { AuthService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { Company } from '@models/company/company.model';

@Component({
    selector: 'app-job-board-settings-visuals',
    templateUrl: './job-board-settings-visuals.form.html',
})
export class JobBoardSettingsVisualsForm extends BaseForm {
    @Input() jobBoard: JobBoard;
    company: Company;
    allowedFileTypes = ['.png', '.jpeg', '.jpg'];
    logo: File | null = null;

    constructor(private auth: AuthService) {
        super();
        this.company = this.auth.company;
    }
}
